import { z } from 'zod';
import { ADJUST_FIELDS } from './adjust-fields.js';
import { refineAdjustReason } from './refine-adjust-reason.js';
export const addInventoryInputSchema = z
    .object({
    requestId: ADJUST_FIELDS.requestId(),
    partId: ADJUST_FIELDS.id('Part'),
    brandId: ADJUST_FIELDS.id('Brand'),
    locationId: ADJUST_FIELDS.id('Location'),
    quantity: ADJUST_FIELDS.quantity(),
    lotNumber: ADJUST_FIELDS.lotNumber(),
    unitCost: ADJUST_FIELDS.unitCost(),
    reasonId: ADJUST_FIELDS.reasonId(),
    note: ADJUST_FIELDS.note(),
    confirmedLotWarning: z.boolean().optional(),
})
    .superRefine((value, context) => refineAdjustReason(value, context, ['ADD']));
//# sourceMappingURL=add-input.js.map